import React from "react";
import Navbar from "../../Components/Navbar/Navbar";

const HomePage = () => {
  return (
    <>
      <Navbar />
      <div class="flex h-auto mt-10 flex-col items-center justify-center space-y-6 bg-gray-100 px-4 sm:flex-row sm:space-x-6 sm:space-y-0">
        <div class="w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-md duration-300 hover:scale-105 hover:shadow-xl">
          <h1 class=" text-center text-2xl font-bold text-gray-500">Sorry!!</h1>
          <p class="my-4 text-center text-sm text-gray-500">No exam found!!</p>
        </div>
      </div>
    </>
  );
};

export default HomePage;
